import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/dateTabStyle';
import { translate } from 'components/Translation';
import { BodyS, HeadingSBold } from 'components/Typography/Typography';
import CustomDatePicker from 'components/CustomDatePicker/CustomDatePicker';
import moment from 'moment';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomRepeatEvery, { PeriodUnit, Period } from 'components/CustomRepeatEvery/CustomRepeatEvery';
import CustomRadio from 'components/CustomRadio/CustomRadio';

// @ts-ignore
const useStyles = makeStyles(styles);

type IDateTabProps = {
	selectedPeriod: PeriodUnit;
	setSelectedPeriod: React.Dispatch<React.SetStateAction<PeriodUnit>>;
	periodicity: string;
	setPeriodicity: React.Dispatch<React.SetStateAction<string>>;
	period: Period;
	setPeriod: React.Dispatch<React.SetStateAction<Period>>;
	isRepeatEnabled: boolean;
	setIsRepeatEnabled: React.Dispatch<React.SetStateAction<boolean>>;
	repeatPeriod: number;
	setRepeatPeriod: React.Dispatch<React.SetStateAction<number>>;
	allowedPeriods: PeriodUnit[];
	numberOfOrders: number;
};

const DateTab = ({
	selectedPeriod,
	periodicity,
	period,
	isRepeatEnabled,
	allowedPeriods,
	repeatPeriod,
	setSelectedPeriod,
	setPeriodicity,
	setPeriod,
	setIsRepeatEnabled,
	setRepeatPeriod,
	numberOfOrders,
}: IDateTabProps) => {
	const classes = useStyles();

	useEffect(() => {
		if (period['endDate'] === undefined) {
			period['endDate'] = period['startDate'];
		}
	}, [isRepeatEnabled, period]);

	return (
		<div className={classes.smallTab}>
			<div className={classes.tab}>
				<div className={classes.headingWrapper}>
					<HeadingSBold color="primary-light">{translate('schedule.date')}</HeadingSBold>
				</div>
				<div className={classes.dateTabContainer}>
					<BodyS inline>{translate('prepaid.loyalty.add.new.services.date.question')}</BodyS>
					<div>
						<CustomRadio
							checked={!isRepeatEnabled}
							label={translate('prepaid.loyalty.run.once')}
							onChange={() => setIsRepeatEnabled(false)}
						/>
						<CustomRadio
							checked={isRepeatEnabled}
							label={translate('prepaid.loyalty.recurrent')}
							onChange={() => setIsRepeatEnabled(true)}
						/>
					</div>
					<ConditionalRender
						show={isRepeatEnabled}
						onTrue={() => (
							<CustomRepeatEvery
								allowedPeriod={allowedPeriods}
								isSummary={true}
								selectedPeriod={selectedPeriod}
								setSelectedPeriod={setSelectedPeriod}
								periodicity={periodicity}
								setPeriodicity={setPeriodicity}
								period={period}
								setPeriod={setPeriod}
								numberOfOrders={numberOfOrders}
								repeatPeriod={repeatPeriod}
								setRepeatPeriod={setRepeatPeriod}
							/>
						)}
						onFalse={() => (
							<div className={classes.datePicker}>
								<div>
									<DateRangeIcon color="disabled" />
								</div>
								<div>
									<CustomDatePicker
										timeFormat={false}
										value={period.startDate}
										onChange={(date) => {
											if (moment.isMoment(date)) {
												setPeriod({
													startDate: date as moment.Moment,
													endDate: null,
												});
											}
										}}
										isValidDate={(currentDate) => {
											return currentDate.isSameOrAfter(moment().startOf('day'));
										}}
										inputProps={{ disabled: false }}
									/>
								</div>
							</div>
						)}
					/>
				</div>
			</div>
		</div>
	);
};
export default DateTab;
